<template>
  <vi-page>
    <vi-card :title="title" line>
      <template v-slot:toolbar>
        <vi-nav line weight="boldest">
          <vi-nav-route :to="`${baseURL}/information`">基本信息</vi-nav-route>
          <vi-nav-route :to="`${walletURL}/wallet`">钱包账户</vi-nav-route>
          <!-- <vi-nav-route :to="`${walletURL}/balance`">客户余额</vi-nav-route> -->
          <vi-nav-route :to="`${userSN}/bill`">客户账单</vi-nav-route>
          <vi-nav-route :to="`${userSN}/order`">客户订单</vi-nav-route>
        </vi-nav>
      </template>
      <template v-slot:default>
        <router-view />
      </template>
    </vi-card>
  </vi-page>
</template>

<script>
export default {
  name: "PagesDashboardCustomerDetail",
  provide() {
    return {
      agent: {
        sn: this.sn,
      },
    };
  },
  data() {
    return {
      sn: this.$route.params.sn,
      baseURL: `/shiyun/distribution/customer/${this.$route.params.sn}/detail`,
      title: "客户详情",
      walletURL: "",
      userSN:"",
      billSN:""
    };
  },
  mounted() {
    this.eGetCustomer();
  },
  methods: {
    eGetCustomer() {
      this.$$.api.data
        .find("/shiyun/aliyun/apis/data/customer", {
          number: this.$route.params.sn,
          columns: ["*","user.*"],
        })
        .then((res) => {
          this.title = `客户详情 - ${res.data.item.name}`
          this.walletURL = `/shiyun/distribution/customer/${res.data.item.sn}/detail`;
          this.userSN = `/shiyun/distribution/customer/${this.$route.params.sn}/detail`;
          this.billSN = `/shiyun/distribution/customer/${res.data.item.userSN}/detail`;
        });
    },
  },
};
</script>

<style>
</style>